/** Ensures that the given value stays within the range defined by min and max. */
export const clamp = (value: number, min: number, max: number): number => Math.min(Math.max(value, min), max);

/** Ensures that the given value stays within the range defined by min and max but if the value is greater than max it returns min and if it's smaller than min it returns max. */
export const flipClamp = (value: number, min: number, max: number): number => {
  if (value > max) return min;
  if (value < min) return max;
  return value;
};
